<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<!-- eslint-disable @angular-eslint/template/use-track-by-function -->
<!-- Create the first row separately so we can include a special spacer cell. -->
@for (row of rows; track row; let rowIndex = $index) {
<tr role="row">
  <!--
    Each gridcell in the calendar contains a button, which signals to assistive technology that the
    cell is interactable, as well as the selection state via `aria-pressed`. See #23476 for
    background.
    -->
  @for (item of row; track item; let colIndex = $index) {
  <td
    role="gridcell"
    class="relative h-0 leading-[0] cursor-pointer border-r-2 border-b-2 border-r-background-container-secondary border-b-background-container-secondary overflow-hidden"
    [style.width]="_cellWidth"
    [class.border-t-background-container-secondary]="rowIndex === 0"
    [class.border-t-2]="rowIndex === 0"
    [class.border-l-background-container-secondary]="colIndex === 0"
    [class.border-l-2]="colIndex === 0"
    [class.rounded-tl]="rowIndex === 0 && colIndex === 0"
    [class.rounded-bl]="rowIndex === rows.length - 1 && colIndex === 0"
    [class.rounded-tr]="rowIndex === 0 && colIndex === row.length -1"
    [class.rounded-br]="rowIndex === rows.length - 1 && colIndex === row.length -1"
    [style.paddingTop]="_cellPadding"
    [style.paddingBottom]="_cellPadding"
    [attr.data-mat-row]="rowIndex"
    [attr.data-mat-col]="colIndex"
    (click)="_cellClicked(item, $event)"
    (focus)="_emitActiveDateChange(item, $event)"
  >
    <button
      class="outline-none border-none m-0 w-full h-full absolute top-0 left-0 flex"
      [ngClass]="item.cssClasses"
      [tabindex]="_isActiveCell(rowIndex, colIndex) ? 0 : -1"
      [class.cursor-default]="!item.enabled"
      [class.bg-custom-border-muted]="!item.enabled"
      [class.text-foreground-primary-60]="!item.enabled"
      [attr.aria-label]="item.ariaLabel"
      [attr.aria-disabled]="!item.enabled || null"
      [attr.aria-pressed]="_isSelected(item.compareValue)"
      [attr.aria-current]="todayValue === item.compareValue ? 'date' : null"
    >
      <div
        class="content-[''] absolute top-0 left-0 w-full h-full flex justify-center items-center font-semibold text-normal"
        [class.bg-action-primary]="_isRangeStart(item.compareValue) || _isRangeEnd(item.compareValue)"
        [class.bg-action-primary-30]="_isInRange(item.compareValue) && !(_isRangeStart(item.compareValue) || _isRangeEnd(item.compareValue))"
        [class.text-foreground-secondary-100]="_isRangeStart(item.compareValue) || _isRangeEnd(item.compareValue)"
      >
        {{item.displayValue}}
      </div>
      <div
        class="content-[''] absolute top-0 left-0 w-full h-full flex justify-center items-center font-semibold text-normal"
        [class.bg-action-primary]="_isPreviewStart(item.compareValue) || _isPreviewEnd(item.compareValue) || _isSelected(item.compareValue)"
        [class.bg-action-primary-30]="_isInPreview(item.compareValue) && !(_isPreviewStart(item.compareValue) || _isPreviewEnd(item.compareValue))"
        [class.text-foreground-secondary-100]="_isPreviewStart(item.compareValue) || _isPreviewEnd(item.compareValue) || _isSelected(item.compareValue)"
      >
        {{item.displayValue}}
      </div>
    </button>
  </td>
  }
</tr>
}
